import { createMachine } from 'xstate';
import * as actions from './actions';

export default function getFormFsm(machineContext) {
    const keepOpenAfterSubmit = machineContext && machineContext.keepOpenAfterSubmit && machineContext.selectedTheme === 'gl2025';
    const machineConfig = {
        ...config,
        states: {
            ...config.states,
            submitted:
                keepOpenAfterSubmit
                    ? {
                          entry: 'raiseSuccess',
                          always: { target: '#Form.edit.ready' }
                      }
                    : {
                          entry: 'raiseSuccess',
                          type: 'final'
                      }
        }
    };
    return createMachine({ context: machineContext, ...machineConfig }, { actions });
}

export const config = {
    id: 'Form',
    initial: 'edit',
    states: {
        view: {},
        edit: {
            initial: 'ready',
            on: {
                change: {
                    target: '.dirty',
                    actions: ['optimisticallyMergeChangedRecord', 'mergeChanges']
                },
                changeSuccess: {
                    target: '.dirty',
                    actions: 'mergeChangedRecord'
                },
                restart: {
                    target: '.ready',
                    actions: 'updateContext'
                },
                restartWithChanges: {
                    target: '.dirty',
                    actions: 'updateContext'
                },
                removedHNode: {
                    target: '.dirty',
                    actions: 'removedHNode'
                }
            },
            states: {
                ready: {},
                dirty: {
                    initial: 'valid',
                    on: {
                        submit: '.submitting'
                    },
                    states: {
                        valid: {},
                        invalid: {},
                        submitting: {
                            initial: 'validating',
                            states: {
                                validating: {
                                    on: {
                                        validate_success: [
                                            {
                                                target: '#Form.edit.dirty.invalid',
                                                cond: (context, event) =>
                                                    Object.keys(event.errors?.field ?? {}).length ||
                                                    event.errors?.form?.length
                                            },
                                            { target: 'updating', cond: context => !context.isNew },
                                            { target: 'creating', cond: context => context.isNew }
                                        ],
                                        validate_failure: '#Form.edit.dirty.invalid'
                                    },
                                    entry: 'validate'
                                },
                                updating: {
                                    on: {
                                        update_success: [
                                            {
                                                target: '#Form.submitted',
                                                cond:  (context, event) => !event.keepOpenAfterSubmit
                                            },
                                            {
                                                target: '#Form.edit.ready',
                                                cond: (context, event) => event.keepOpenAfterSubmit
                                            }
                                        ],
                                        update_failure: '#Form.edit.dirty.invalid'
                                    },
                                    entry: 'update'
                                },
                                creating: {
                                    on: {
                                        create_success: '#Form.submitted',
                                        create_failure: '#Form.edit.dirty.invalid'
                                    },
                                    entry: 'create'
                                }
                            }
                        }
                    }
                }
            }
        },
        submitted: {
            entry: 'raiseSuccess',
            always: { target: 'edit.ready' }
        }
    }
};
